import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const GET_DENIAL_HISTORY_LIST = "GET_DENIAL_HISTORY_LIST";

export const service = async (data) => {  
  const options: object = {
    url: "/api/DenialsPredictor/GetDenialHistoryList",
    method: "POST",
    headers: {
      "Content-Type": "application/json",},
    body: JSON.stringify(data),
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};


register(GET_DENIAL_HISTORY_LIST, service, mock);
